export default {
    plainTextPlaceholder: 'Type your answer here',
    plainTextTooltip:
        'Press Enter to go to the next question.\nShift+Enter to add a new paragraph.',
    successTitle: 'Your answer have been submitted successfully',
    successButtonLabel: 'Home',
    closePreview: 'Close preview',
    closeWindow: 'You may now close the window.',
    evaluationClosed: {
        pill: 'Evaluation Closed',
        title: 'This evaluation is no longer available',
        description:
            'The deadline for this evaluation has passed or the evaluation has been deleted. You can no longer submit or update your answers.',
        errorTitle: 'Evaluation Unavailable',
        errorMessage:
            'This evaluation is no longer available. You can no longer submit or update your answers.',
    },
    alreadyAnswered: {
        pill: 'Evaluation submitted',
        title: 'You have already answered this evaluation',
        description: 'Answers can no longer be edited once they have been submitted.',
    },
    unavailable: {
        pill: 'Evaluation not found',
        title: 'This evaluation is not available.',
        description:
            'The link you opened does not lead to any evaluation. Open the evaluation from its invitation link.',
        respondentRemoved: 'You are no longer invited to answer this evaluation.',
    },
    answerLoadError: {
        pill: 'Loading error',
        title: 'This evaluation could not be loaded.',
        description: 'Check your connection, then try again.',
        retry: 'Try again',
    },
    commentThread: {
        title360: 'Your 360 feedback on {{name}}',
        title360WithoutName: 'Your 360 feedback',
        titleSelfEvaluation: 'Your self-assessment',
        questionPosition: 'Question {{current}} of {{total}}',
        whatYouWrote: 'What you wrote',
        signedBy: 'Signed',
        signedNameNeverShown: '(your name is never shown)',
        signedAnonymously: 'Anonymous: your replies are signed “{{respondent}}”.',
        signedWithName: 'Your replies are signed with your name.',
        replyLabel: 'Your reply',
        replyPlaceholder: 'Write your reply',
        send: 'Reply',
        sent: 'Your reply was sent.',
        replyRefused:
            'Your reply was not sent: it must contain text and stay within {{maxLength}} characters. It is still in the field.',
        repliesClosed:
            'Replies to comments are disabled for this evaluation: you can read the conversation, but not reply to it.',
        repliesClosed360:
            'Replies to comments are disabled for this 360 feedback: you can read the conversation, but not reply to it.',
        unsentReply: 'Your reply was not sent:',
        repliesClosedRefused:
            'Replies to comments have just been disabled for this 360 feedback: your reply was not sent.',
        goneRefused:
            'This 360 feedback is no longer available: your reply was not sent. It stayed in the field.',
        noComments: 'You left no comments in your answers.',
        loadErrorTitle: 'The comments could not be loaded.',
        loadError: 'Check your connection, then try again.',
        retry: 'Try again',
        open: 'See the replies to your comments',
        unavailable: {
            pill: 'Comments not available',
        },
        notFound: {
            pill: 'Comments not available',
            title: 'These comments are not available.',
            description:
                'The link may be incomplete, or the comments may have been removed. Open it again from the latest email you received.',
        },
        anotherPerson: {
            pill: 'Someone else’s link',
            title: 'This link belongs to someone else.',
            description:
                'You are signed in with an account other than the one this link was sent to. Sign out, or open the link in a private browsing window.',
        },
    },
};
